/**
 * Shared "public email domain" blocklist for lead capture forms.
 *
 * Mirrors ``backend/services/email_domains.py``; if you add to one,
 * add to the other. Keep this file dependency-free so it can be
 * imported from anywhere (validation utils, landing templates, etc.).
 */

export const BLOCKED_EMAIL_DOMAINS = [
  // Big mailbox providers
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'aol.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'live.com',
  'msn.com',
  'mail.com',
  // Privacy-focused free mail
  'protonmail.com',
  'proton.me',
  'pm.me',
  'tutanota.com',
  'fastmail.com',
  // Regional / international consumer providers
  'yandex.com',
  'yandex.ru',
  'mail.ru',
  'qq.com',
  '163.com',
  '126.com',
  'sina.com',
  'rediffmail.com',
  'inbox.com',
  'gmx.com',
  'gmx.net',
  'zoho.com',
];

const BLOCKED_SET = new Set(BLOCKED_EMAIL_DOMAINS);

/**
 * Lower-cased domain (the part after the final ``@``). Returns ``''``
 * for malformed input so callers don't have to wrap this.
 */
export function extractDomain(email) {
  if (!email || typeof email !== 'string' || !email.includes('@')) return '';
  return email.split('@').pop().trim().toLowerCase();
}

/** True if ``email``'s domain is on the public-mailbox blocklist. */
export function isBlockedEmailDomain(email) {
  return BLOCKED_SET.has(extractDomain(email));
}
